import { render } from "./EditContact.vue?vue&type=template&id=3a7fff64&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"

import "./EditContact.vue?vue&type=style&index=0&id=3a7fff64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7fff64"]])

export default __exports__